import { NumberEdit } from '@powerportalspro/react-fluent';

export function NumberEditMainSample() {
  return <NumberEdit columnName="ppp_percentcomplete" valueType="decimal" />;
}
